
export default function DownArrow() {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.79822 19.1C13.6048 19.1 17.4936 15.0214 17.4936 10C17.4936 4.97859 13.6048 0.9 8.79822 0.9C3.99163 0.9 0.102881 4.97859 0.102881 10C0.102881 15.0214 3.99163 19.1 8.79822 19.1Z"
        stroke="#5C5C5C"
        stroke-width="0.2"
      />
      <path
        d="M8.79828 10.7929L6.63184 8.14645C6.472 7.95118 6.21284 7.95118 6.05299 8.14645C5.89314 8.34171 5.89314 8.65829 6.05299 8.85355L8.50885 11.8536C8.6687 12.0488 8.92786 12.0488 9.08771 11.8536L11.5436 8.85355C11.7034 8.65829 11.7034 8.34171 11.5436 8.14645C11.3837 7.95118 11.1246 7.95118 10.9647 8.14645L8.79828 10.7929Z"
        fill="#565656"
      />
      <mask
        id="mask0_2036_2733"
        // style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="5"
        y="8"
        width="7"
        height="4"
      >
        <path
          d="M8.79828 10.7929L6.63184 8.14645C6.472 7.95118 6.21284 7.95118 6.05299 8.14645C5.89314 8.34171 5.89314 8.65829 6.05299 8.85355L8.50885 11.8536C8.6687 12.0488 8.92786 12.0488 9.08771 11.8536L11.5436 8.85355C11.7034 8.65829 11.7034 8.34171 11.5436 8.14645C11.3837 7.95118 11.1246 7.95118 10.9647 8.14645L8.79828 10.7929Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_2036_2733)"></g>
    </svg>
  );
}
